import { useCallback, useRef } from 'react';

export const usePersistCallback = <T extends (...args: any[]) => any>(
  fn?: T
) => {
  const ref = useRef<T>();
  ref.current = fn;
  return useCallback(
    (...args) => {
      const callback = ref.current;
      return callback && callback(...args);
    },
    [ref]
  );
};
